import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { colors } from "../../../global";
import DataTableComponent from "../../../shared/components/DataTableComponent";

export default function BenchmarkCard({
  benchmarkName,
  data,
  isCheck,
  onCheckChange,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const uniqueKeys = Array.from(
    new Set(data.flatMap((item) => Object.keys(item)))
  );

  const orderedData = data.map((item) =>
    uniqueKeys.map((key) => item[key] ?? "")
  );

  return (
    <>
      <div
        className="mb-4 overflow-hidden rounded shadow-sm border"
        style={{ borderColor: colors.primary, borderRadius: "0.5rem" }}
      >
        <div
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex flex-wrap justify-between items-center p-3 cursor-pointer"
          style={{ backgroundColor: colors.accent, color: colors.white }}
        >
          <span className="font-medium text-sm truncate max-w-xs sm:max-w-md">
            {benchmarkName}
          </span>
          <div
            className="flex flex-wrap gap-2 sm:gap-2 items-center mt-3 sm:mt-0"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative inline-block">
              <input
                type="checkbox"
                checked={isCheck}
                onChange={(e) => {
                  e.stopPropagation();
                  onCheckChange();
                }}
                className="sr-only"
              />
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  onCheckChange();
                }}
                className={`w-5 h-5 rounded-full border-2 transition-all duration-200 ease-in-out cursor-pointer flex items-center justify-center ${
                  isCheck
                    ? "bg-primary border-primary hover:bg-secondary"
                    : "bg-white border-gray-300 hover:border-primary"
                } focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2`}
              >
                {isCheck && (
                  <svg
                    className="w-3 h-3 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                )}
              </div>
            </div>

            <button
              onClick={(e) => e.stopPropagation()}
              className="text-white w-8 h-8 flex items-center justify-center"
              aria-label={isExpanded ? "Collapse" : "Expand"}
            >
              <FontAwesomeIcon
                icon={isExpanded ? faChevronUp : faChevronDown}
              />
            </button>
          </div>
        </div>

        {isExpanded && (
          <div className="flex flex-col p-3 text-center bg-gray-50 ">
            <DataTableComponent
              className="p-6 bg-white rounded-xl border border-gray-100 shadow-sm over text-left"
              columns={uniqueKeys}
              data={orderedData}
              options={{
                scrollX: true,
                scrollY: "600px",
                scrollCollapse: true,
                paging: true,
                fixedColumns: {
                  leftColumns: 3,
                },
                // responsive:true
              }}
            />
          </div>
        )}
      </div>
    </>
  );
}
